export default {
  namespaced: true,
  state: {
    backHref: "",
    pageTitle: "",
    searchBar: false,
    notifications: [],
    customButtons: [],
    runningTask: null,
  },
  getters: {
    getBackHref: state => state.backHref,
    getNotifications: state => state.notifications,
    customButtons: state => state.customButtons
  },
  mutations: {
    setHeadbarTitle: (state, title) => {
      state.pageTitle = title;
    },
    setBackHref: (state, href) => {
      state.backHref = href;
    },
    enableSearchbar: state => {
      state.searchBar = true;
    },
    disableSearchbar: state => {
      state.searchBar = false;
    },
    updateNotifications: (state, notifications) => {
      notifications.forEach(notification => {
        state.notifications.push(notification);
      });
    },
    setRead: (state, ts) => {
      const notifications = state.notifications;
      state.notifications = notifications.map(n => {
        if(n.timestamp < ts && n.read == 0) {
          n.read = 1;
        }
        return n;
      });
    },
    addButtons: (state, btns) => {
      state.customButtons = state.customButtons.concat(btns);
    },
    removeButtons: (state) => {
      state.customButtons = [];
    },
    runningTask: (state, task) => {
      state.runningTask = task;
    }
  },
  actions: {
    setHeadbarTitle: async ({ commit }, title) => {
      commit("setHeadbarTitle", title);
    },
    setBackHref: async ({ commit }, href) => {
      commit("setBackHref", href);
    },
    enableSearchbar: async ({ commit }) => {
      commit("enableSearchbar");
    },
    disableSearchbar: async ({ commit }) => {
      commit("disableSearchbar");
    },
    updateNotifications: async ({ commit }, notifications) => {
      commit('updateNotifications', notifications);
    },
    setRead: async ({ commit }, ts) => {
      commit('setRead', ts);
    },
    addButtons: async ({ commit }, btns) => {
      commit('addButtons', btns);
    },
    removeButtons: async ({ commit }) => {
      commit('removeButtons');
    }
  }
};
